module.exports = "/_next/static/images/solutions-7762c2a29fe87571ade22ebf331890a7.png";